// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"520":"18a59af2","779":"e3315957","839":"6c5ae7e0","846":"ecdb8535"}[chunkId] + ".css";
};